import { toast } from "react-toastify";
import axiosInstance from "../../axiosInterceptor";
import { useState } from "react";
import { useFormik } from "formik";
import { changePasswordSchema, updateProfileSchema, } from "../../Validation/Validation";
import { useProfile } from "../../context/ProfileContext";

const Profile = () => {
  const { profile, refreshProfile } = useProfile();
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);
  const profileFormik = useFormik({
    initialValues: {
      userName: profile?.fullName || "",
      email: profile?.email || "",
    },
    validationSchema: updateProfileSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoadingProfile(true);
      try {
        const res = await axiosInstance.post("/profile", {
          userName: values.userName,
        });

        if (res.status === 200) {
          toast.success(res.data?.message || "Profile updated successfully");
          refreshProfile()
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Profile update failed");
      } finally {
        setLoadingProfile(false);
      }
    },
  });

  const passwordFormik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: changePasswordSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoadingPassword(true);
      try {
        const res = await axiosInstance.post("admin/changePassword", {
          oldPassword: values.currentPassword,
          newPassword: values.newPassword,
        });

        if (res.status === 200) {
          toast.success(res.data?.message || "Password changed successfully");
          resetForm();
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Password change failed");
      } finally {
        setLoadingPassword(false);
      }
    },
  });

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="page-title">Profile</h3>
      </div>

      <div className="row px-3">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h5 className="mb-3">Profile Information</h5>
              <form onSubmit={profileFormik.handleSubmit}>
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="userName"
                    className="form-control form-control-sm"
                    value={profileFormik.values.userName}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                    placeholder="Enter name"
                  />
                  {profileFormik.touched.userName &&
                    profileFormik.errors.userName && (
                      <small className="text-danger">
                        {profileFormik.errors.userName}
                      </small>
                    )}
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control form-control-sm bg-light"
                    value={profileFormik.values.email}
                    readOnly
                    placeholder="Enter email"
                  />
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm mt-2 p-3"
                    disabled={loadingProfile}
                  >
                    {loadingProfile ? "Processing..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h5 className="mb-3">Change Password</h5>

              <form onSubmit={passwordFormik.handleSubmit}>
                <div className="form-group">
                  <label>Current Password</label>
                  <input
                    type="password"
                    name="currentPassword"
                    className="form-control form-control-sm"
                    value={passwordFormik.values.currentPassword}
                    onChange={passwordFormik.handleChange}
                    onBlur={passwordFormik.handleBlur}
                    placeholder="Enter current password"
                  />
                  {passwordFormik.touched.currentPassword &&
                    passwordFormik.errors.currentPassword && (
                      <small className="text-danger">
                        {passwordFormik.errors.currentPassword}
                      </small>
                    )}
                </div>

                <div className="form-group">
                  <label>New Password</label>
                  <input
                    type="password"
                    name="newPassword"
                    className="form-control form-control-sm"
                    value={passwordFormik.values.newPassword}
                    onChange={passwordFormik.handleChange}
                    onBlur={passwordFormik.handleBlur}
                    placeholder="Enter new password"
                  />
                  {passwordFormik.touched.newPassword &&
                    passwordFormik.errors.newPassword && (
                      <small className="text-danger">
                        {passwordFormik.errors.newPassword}
                      </small>
                    )}
                </div>

                <div className="form-group">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    className="form-control form-control-sm"
                    value={passwordFormik.values.confirmPassword}
                    onChange={passwordFormik.handleChange}
                    onBlur={passwordFormik.handleBlur}
                    placeholder="Enter confirm password"
                  />
                  {passwordFormik.touched.confirmPassword &&
                    passwordFormik.errors.confirmPassword && (
                      <small className="text-danger">
                        {passwordFormik.errors.confirmPassword}
                      </small>
                    )}
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm mt-2 p-3"
                    disabled={loadingPassword}
                  >
                    {loadingPassword ? "Processing..." : "Change Password"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
